import { render, staticRenderFns } from "./GridPersonalDetails.vue?vue&type=template&id=3d257fce&scoped=true&"
import script from "./GridPersonalDetails.vue?vue&type=script&lang=js&"
export * from "./GridPersonalDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d257fce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d257fce')) {
      api.createRecord('3d257fce', component.options)
    } else {
      api.reload('3d257fce', component.options)
    }
    module.hot.accept("./GridPersonalDetails.vue?vue&type=template&id=3d257fce&scoped=true&", function () {
      api.rerender('3d257fce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/personal-details/grid/GridPersonalDetails.vue"
export default component.exports